module.exports = __webpack_public_path__ + "static/media/withoutTick.fe6672c0.svg";